import { FieldLabel, Input } from "@braze/beacon-core";
import { FormContainer } from "./FormContainer";
import { useState } from "react";
import { FieldProps } from "./types";

interface RequiredDateProps extends FieldProps {
    minDate?: string;
}

export const RequiredDate = (props: RequiredDateProps) => {
    const [invalid, setInvalid] = useState(true);

    return (
        <FormContainer>
            <FieldLabel label={props.name} status={invalid ? "danger":"success"} statusText={props.name+" is required"}>
                <Input type="date" fullWidth invalid={invalid} name={props.name}
                    min={props.minDate}
                    onChange={(e) => {
                        if (!e.target.value) {
                            props.handleChange(e.target.value);
                            setInvalid(true);}
                        else {
                            setInvalid(false);
                            props.handleChange(e.target.value);
                        }
                }}/>
            </FieldLabel>
        </FormContainer>
    )
}